export default "__VITE_ASSET__6fGaFN60__"